// @todo: Refactor to constants when API will be ready
const chargesFields = [
  {
    field: 'commands',
    title: 'Actions',
    cell: 'commands',
    sortable: false,
    hidden: false,
    locked: true,
    width: 80,
  },
  {
    title: 'Type',
    field: 'type',
    width: 100,
  },
  {
    title: 'Description',
    field: 'description',
    width: 200,
  },
  {
    title: 'Amount',
    field: 'amount',
    width: 100,
  },
];

export default chargesFields;
